export default __webpack_public_path__ + "static/media/bg-1of7.00703066.svg";